import styled from "styled-components";
export const Layout = styled.button `
  ${({ theme }) => theme.font.t3};
  background-color: ${({ $isSelected }) => ($isSelected ? "#DBE4FC" : "white")};
  border: 1px solid;
  border-color: ${({ $isSelected, theme }) => $isSelected ? theme.color.s1 : "#DBE4FC"};
  border-radius: 8px;
  color: ${({ theme }) => theme.color.s1};
  cursor: pointer;
  display: block;
  height: 32px;
  padding: 6px 12px 6px 12px;
  &:hover {
    background-color: #dbe4fc;
    filter: brightness(1.05);
  }
`;
